/*
 * @Author: DQL
 * @Date: 2020-09-02 11:01:18
 * @LastEditors: zxf
 * @LastEditTime: 2022-03-13 20:16:37
 * @Description: file content
 */
import PieChart from './PieChart';
import LineLineChart from './LineLineChart';

const ChartComponents = {};
/* istanbul ignore next */
ChartComponents.install = function (Vue) {
  Vue.component(PieChart.name, PieChart);
  Vue.component(LineLineChart.name, LineLineChart);
};

export default ChartComponents;
